import { Project } from '../model'

export const PREVIEW_URL = process.env.REACT_APP_VIEWER_DEV_URL || '#'

export const PRODUCTION_URL = process.env.REACT_APP_VIEWER_URL || '#'

export interface ProjectPreviewPopupProps {
    stage: 'prod' | 'dev'
    project: Project
    onClose(): any
}
